import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled from 'styled-components';
import { themeGet, getPaletteColor, getBackgroundColor, getTextColor } from '@magalu/stereo-ui-styles';
import { AnimatedLoading1 } from '@magalu/stereo-ui-icons';
import Button from '../../atoms/Button';
import Input from '../../atoms/Input';
import Text from '../../atoms/Text';
export const Container = styled.form`
  position: relative;
`;
export const Label = styled.label`
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  color: ${_ref => {
  let {
    hasError
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["hasError"]);

  return getPaletteColor(!hasError ? 'base' : 'error.base')(props);
}};
`;
export const StyledInput = styled(Input)`
  border: 0;
  width: 100%;
  border-radius: 0;
  border-bottom: 1px solid;
  border-color: ${_ref2 => {
  let {
    hasError
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, ["hasError"]);

  return getPaletteColor(!hasError ? 'base' : 'error.base')(props);
}};
  padding: 0 0 ${props => themeGet('space.2')(props)}px;
  line-height: ${props => themeGet('lineHeights.input')(props)};
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
  background-color: transparent;
  margin-top: 4px;
  &::placeholder {
    color: ${props => getTextColor('greyish')(props)};
  }
`;
export const Icon = styled.div`
  width: 100%;
  opacity: 0.8;
  position: absolute;
  text-align: center;
  background-color: ${props => getBackgroundColor('base')(props)};
  z-index: ${props => themeGet('zIndices.0')(props)};
`;
export const AnimatedLoader = styled(AnimatedLoading1).attrs(props => ({
  color: getPaletteColor('primary')(props)
}))`
  height: 40px;
`;
export const StyledButton = styled(Button).attrs(() => ({
  m: '14px 0'
}))`
  width: 70%;
`;
export const StyledSpan = styled(Text).attrs(() => ({
  forwardedAs: 'span',
  color: 'text.primary',
  fontSize: 1,
  fontWeight: 'medium',
  textAlign: 'center',
  textTransform: 'uppercase'
}))`
  cursor: pointer;
  margin: 14px;
  text-transform: uppercase;
  width: 70%;
`;